import {Notification} from "element-ui";

let socket = null;//实例对象
let lockReconnect = false; //是否真正建立连接
const timeout = 30 * 1000; //心跳间隔时间
let timeoutObj = null; //心跳倒计时
let serverTimeoutObj = null; //服务心跳倒计时
let timeoutnum = null; //断开 重连倒计时
const initWebSocket = async (key, getMessageFunction) => {
  if ("WebSocket" in window) {
    //判断是否已经连接
    if (socket) {
      addMessageGetCallBack(key, getMessageFunction);
      return;
    }
    const host = process.env.NODE_ENV !== 'production' ? 'http://127.0.0.1:8108' : window.location.origin;
    const token = localStorage.getItem('tokenVue') || '';
    const wsUrl = `${host}/websocket/${token}`;
    socket = new WebSocket(wsUrl);
    socket.onerror = webSocketOnError;
    socket.onmessage = webSocketOnMessage;
    socket.onclose = closeWebsocket;
    socket.onopen = openWebsocket;
    addMessageGetCallBack(key, getMessageFunction);
    window.onbeforeunload = () => close("用户关闭页面");
  } else {
    Notification.error({
      title: "错误",
      message: "您的浏览器不支持websocket，请更换Chrome或者Firefox",
    });
  }
}
const addMessageGetCallBack = (key, callback) => {
  if (callback) {
    if (!socket.getMessageFunction) {
      socket.getMessageFunction = {};
      socket.getMessageFunction[key] = [callback];
    } else {
      if (!socket.getMessageFunction[key]) {
        socket.getMessageFunction[key] = [callback];
      } else {
        socket.getMessageFunction[key].push(callback);
      }
    }
  }
}

const removeMessageGetCallBack = key => {
  socket.getMessageFunction && socket.getMessageFunction[key] && delete socket.getMessageFunction[key];
}
//建立连接
const openWebsocket = (e) => {
  console.log("open websocket:" + JSON.stringify(e));
  start();
}

const start = () => {
  //开启心跳
  timeoutObj && clearTimeout(timeoutObj);
  serverTimeoutObj && clearTimeout(serverTimeoutObj);
  timeoutObj = setTimeout(function () {
    console.log('心跳检测开始');
    //这里发送一个心跳，后端收到后，返回一个心跳消息
    if (socket.readyState === 1) {
      //如果连接正常
      socket.send("heartbeat");
      console.log('心跳检测--正常');
    } else {
      //否则重连
      reconnect();
      console.log('心跳检测--失败重连');
    }
    serverTimeoutObj = setTimeout(function () {
      //超时关闭
      socket.close();
    }, timeout);
    console.log('心跳检测结束');
  }, timeout);
}

//重新连接
const reconnect = () => {
  if (lockReconnect) {
    return;
  }
  lockReconnect = true;
  //没连接上会一直重连，设置延迟避免请求过多
  timeoutnum && clearTimeout(timeoutnum);
  timeoutnum = setTimeout(function () {
    //新连接
    initWebSocket();
    lockReconnect = false;
  }, 1000);
}

//重置心跳
const reset = () => {
  stop();
  //重启心跳
  start();
}

const stop = () => {
  //清除时间
  clearTimeout(timeoutObj);
  clearTimeout(serverTimeoutObj);
}
const sendWebsocket = (e) => {
  socket.send(e);
}

const webSocketOnError = (e) => {
  console.log("socket.onError:" + JSON.stringify(e));
  // if (!isClose) {
  //   initWebSocket();
  //   reconnect();
  // } else {
  //   isClose = false;
  // }
}

//服务器返回的数据
const webSocketOnMessage = (e) => {
  if (!e) {
    return;
  }
  const data = JSON.parse(e.data);
  const tokenVue = localStorage.getItem("tokenVue");
  //判断是否登录
  if (tokenVue) {
    if (data.status === 0) {
      //window自定义事件[下面有说明]
      const type = data.data.type;
      const messageFunctionElement = socket.getMessageFunction[type];
      if (messageFunctionElement) {
        if (Array.isArray(messageFunctionElement) && messageFunctionElement.length > 0) {
          messageFunctionElement.forEach(item => {
            item(data?.data?.data);
          });
        }
      } else {
        window.dispatchEvent(
          new CustomEvent("onmessageWS", {
            data: JSON.parse(data?.data),
          })
        );
      }
    }
  }
  reset();
}

const closeWebsocket = (e) => {
  // reconnect();
}

//断开连接
const close = (ev) => {
//WebSocket对象也有发送和关闭的两个方法，只需要在自定义方法中分别调用send()和close()即可实现。
  if (socket) {
    socket.close();
    socket = null;
    console.log('socket 断开: ' + JSON.stringify(ev));
  }
  stop();
}
//具体问题具体分析,把需要用到的方法暴露出去
export default {
  removeMessageGetCallBack,
  addMessageGetCallBack,
  initWebSocket,
  sendWebsocket,
  webSocketOnMessage,
  close
};



// WEBPACK FOOTER //
// ./src/utils/websocket.js